<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Rufnummernmitnahme</div>
<ng-container *ngIf="businessPorting.porting">
    Rufnummern: {{ portingNumbers }}<br />
    Aktueller Anbieter: {{ businessPorting.provider }}<br />
</ng-container>
<ng-container *ngIf="!businessPorting.porting">
    keine Rufnummernmitnahme<br />
</ng-container>
